// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.team {
  min-width: 750px;
  width: 60vw;
  padding: 20px 40px;
  box-sizing: border-box;
  max-height: 90vh;
  overflow-y: auto;
}
div.team h1 {
  color: #444;
  margin-bottom: 32px;
}
div.team div.bubbles {
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
}
div.team div.bubbles div.person-bubble {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 33%;
  text-align: center;
  padding-bottom: 40px;
  box-sizing: border-box;
}
div.team div.bubbles div.person-bubble img {
  height: 100px;
  width: 100px;
  border-radius: 50%;
}
div.team div.bubbles div.person-bubble h2 {
  color: #444;
  margin: 20px 0 4px 0;
  text-align: center;
  font-size: 22px;
}
div.team div.bubbles div.person-bubble article {
  text-align: center;
  width: 80%;
  color: rgba(0, 0, 0, 0.6);
  opacity: 0.8;
  text-transform: uppercase;
  font-size: 16px;
}
div.team div.bubbles div.person-bubble i.fa {
  font-size: 30px;
  opacity: 0.4;
  cursor: pointer;
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/app/team/team.component.scss","webpack://./src/styles/colors.scss"],"names":[],"mappings":"AACA;EACI,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;AAAJ;AAEI;EACI,WCVI;EDWJ,mBAAA;AAAR;AAEI;EACI,aAAA;EACA,uBAAA;EACA,eAAA;AAAR;AACQ;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,UAAA;EACA,kBAAA;EACA,oBAAA;EACA,sBAAA;AACZ;AAAY;EACI,aAAA;EACA,YAAA;EACA,kBAAA;AAEhB;AAAY;EACI,WC/BJ;EDgCI,oBAAA;EACA,kBAAA;EACA,eAAA;AAEhB;AAAY;EACI,kBAAA;EACA,UAAA;EACA,yBCrCJ;EDsCI,YAAA;EACA,yBAAA;EACA,eAAA;AAEhB;AACY;EACI,eAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;AAChB","sourcesContent":["@use 'colors' as *;\ndiv.team {\n    min-width: 750px;\n    width: 60vw;\n    padding: 20px 40px;\n    box-sizing: border-box;\n    max-height: 90vh;\n    overflow-y: auto;\n\n    h1 {\n        color: $text-dark;\n        margin-bottom: 32px;\n    }\n    div.bubbles {\n        display: flex;\n        align-items: flex-start;\n        flex-wrap: wrap;\n        div.person-bubble {\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n            width: 33%;\n            text-align: center;\n            padding-bottom: 40px;\n            box-sizing: border-box;\n            img {\n                height: 100px;\n                width: 100px;\n                border-radius: 50%;\n            }\n            h2 {\n                color: $text-dark;\n                margin: 20px 0 4px 0;\n                text-align: center;\n                font-size: 22px;\n            }\n            article {\n                text-align: center;\n                width: 80%;\n                color: $dark-gray;\n                opacity: 0.8;\n                text-transform: uppercase;\n                font-size: 16px;\n            }\n\n            i.fa {\n                font-size: 30px;\n                opacity: 0.4;\n                cursor: pointer;\n                display: none;\n            }\n        }\n    }\n}\n","$text-dark: #444;\n\n$dark-gray: rgba(0,0,0,0.6);\n$light-gray: rgba(0,0,0,0.10);\n\n$dates-background: rgba(0,0,0,0.05);\n\n// cornelsen colors\n$cv-red: rgb(222,41,34);\n$cv-grass-dark: rgb(107,171,45);\n$cv-grass-medium: rgb(177,198,16);\n$cv-grass-light: rgb(220,235,205);\n$cv-sky-dark: rgb(0,148,170);\n$cv-sky-medium: rgb(109,186,210);\n$cv-sky-light: rgb(210,235,235);\n$cv-sand-dark: rgb(175,157,140);\n$cv-sand-medium: rgb(212,202,189);\n$cv-sand-light: rgb(240,230,225);\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
